import * as React from 'react'
import styled from 'styled-components'

import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'

const HOUSE_PATH = (
  <g>
    <path
      d="M32.525 13.287 17.838 1.131c-.488-.4-1.188-.4-1.675 0L1.475 13.287a1.316 1.316 0 0 0-.175 1.85 1.31 1.31 0 0 0 1.85.175l.406-.337v12.256a3.937 3.937 0 0 0 3.938 3.938h19.012a3.937 3.937 0 0 0 3.938-3.938V14.975l.406.338a1.317 1.317 0 0 0 1.85-.176 1.317 1.317 0 0 0-.175-1.85ZM20.294 28.544h-12.8A1.312 1.312 0 0 1 6.18 27.23V12.8l10.82-8.95 10.818 8.956v14.432c0 .724-.588 1.312-1.313 1.312h-6.212v-.006Z"
      stroke-width=".5"
    />
  </g>
)

const ID = 'house-stroke-glyph-icon'

export function HouseSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id}>
      {HOUSE_PATH}
    </symbol>
  )
}

const HouseStandaloneContent = standalone(HouseSymbol, ID)

export const House = styled(function HouseComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="house">
      <HouseStandaloneContent />
    </Icon>
  )
})``

export const HouseLightweight = styled(function HouseComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="house-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
